module.exports = __webpack_public_path__ + "img/signButton.7317b266.png";